import queryString from 'query-string';

const Search = ({ location }) => {
  const {
    provider_id: providerId,
    specialty_id: specialtyId,
  } = queryString.parse(location.search);

  if (providerId) {
    return window.location.assign(`
      ${process.env.REACT_APP_HOMEPAGE_URL}/specialties/search?providerId=${providerId}
    `);
  }

  if (specialtyId) {
    return window.location.assign(`
      ${process.env.REACT_APP_HOMEPAGE_URL}/specialties/search?specialtyId=${specialtyId}
    `);
  }

  return window.location.assign(process.env.REACT_APP_HOMEPAGE_URL);
};

export default Search;
